import React from 'react'
import parse from 'html-react-parser'
import * as E from '../../elementor'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import SmoothScrollLink from '../transition/smooth-scroll-link'

const ExperimentalCTA = ({ section }): React.JSX.Element => {
  const { heading = [], textEditor = [], button = [] } = E.collect(section)
  const isScrollLink = button[0]?.link?.includes('#')

  return (
    <section>
      <div className={['experimental-cta-wrapper', section.cssClasses].join(' ')}>
        <h2 className='experimental-cta-header'>{parse(heading[0] !== undefined ? heading[0].title : '')}</h2>
        <p className='experimental-cta-subheader paragraph'>{parse(textEditor[0] !== undefined ? textEditor[0].text() : '')}</p>
        {button[0]?.link !== undefined
          ? isScrollLink === true
            ? (
              <SmoothScrollLink offset={100} offsetMobile={0} id={button[0]?.link} className='experimental-cta-link'>
                <button className={['rula-button', section.cssClasses].join(' ')}>{button[0]?.text}</button>
              </SmoothScrollLink>
              )
            : (
              <AniLink href={button[0]?.link} className='experimental-cta-link'>
                <button className={['rula-button', section.cssClasses].join(' ')}>{button[0]?.text}</button>
              </AniLink>
              )
          : null}
      </div>
    </section>
  )
}

export default ExperimentalCTA
